angular.module('gym.components').directive('accessControlActivity', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/access_control/access_control_activity.html.slim'),
    scope: {
      activity: '='
    }
  };
});
